import { render, staticRenderFns } from "./ShowVideo.vue?vue&type=template&id=f5bfdb58&scoped=true&"
import script from "./ShowVideo.vue?vue&type=script&lang=ts&"
export * from "./ShowVideo.vue?vue&type=script&lang=ts&"
import style0 from "./ShowVideo.vue?vue&type=style&index=0&id=f5bfdb58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bfdb58",
  null
  
)

export default component.exports